<template>
  <van-loading color="#1989fa" size="32" vertical>加载中...</van-loading>
</template>
<script>
export default {
  name: "Loading",
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style scoped  lang="less">
.van-loading {
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.2);
}
</style>
